export default function formatPercent(n, d) {
  if (d == null || d <= 0) return '0.0';

  return (n / d * 100).toFixed(1);
}



// WEBPACK FOOTER //
// ./utils/format-percent.js